<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <ClientNav class="hideOnPrint" />
    <v-row dense class="hideOnPrint">
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" tile height="100%">
          <v-tabs v-model="tab">
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(item, i) in items" :key="item">
              <v-data-table
                :headers="headers"
                :items="i === 0 ? supports : disabled"
                sort-by="StartDate"
                sort-desc
                :loading="isLoading"
                loading-text="Loading Support Strategies"
                :search="search"
                height="550"
              >
                <template v-slot:item.select=""> </template>
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Support Strategies</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      clearable
                      flat
                      solo-inverted
                      hide-details
                      prepend-inner-icon="search"
                      label="search"
                      class="desktop"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn
                      fab
                      small
                      @click="printTable()"
                      class="mr-8 mb-2 white--text"
                      color="#2b6993"
                      elevation="4"
                    >
                      <v-icon>print</v-icon>
                    </v-btn>

                    <v-btn
                      color="#2b3990"
                      dark
                      class="mb-2"
                      @click="showAdd()"
                      v-if="!readonly && !isAuditorRole"
                    >
                      <v-icon left>add</v-icon>
                      Add Support Strategy</v-btn
                    >
                  </v-toolbar>

                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="mobile ml-5 mr-5 mb-3 mt-3"
                  ></v-text-field>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="viewSupport(item)">
                    mdi-eye
                  </v-icon>
                  <v-icon small @click="deleteSupport(item)">
                    mdi-delete
                    </v-icon>
                </template>
                <template v-slot:no-data>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="getSupports()"
                    >Reset</v-btn
                  >
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint" />

    <div id="printTable">
      <h2 class="text-center ma-3">Support Strategies</h2>
      <v-row>
        <v-col cols="12" sm="12">
          <v-data-table
            :headers="headers"
            :items="supports"
            sort-by="StartDate"
            sort-asc
            :loading="isLoading"
            loading-text="Loading Support Strategies"
            :search="search"
            :items-per-page="-1"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Support Strategies</v-toolbar-title>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div id="printItem">
      <h2 class="text-center ma-3">Support Strategy</h2>
      <v-row>
        <v-col cols="12" sm="12" md="3">
          <!-- <v-text-field
            label="Goal"
            v-model="newGoal"
        >
        </v-text-field>  -->
          <h3>Goal</h3>
          <div>
            {{ newGoal }}
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="3">
          <!-- <v-text-field
        v-model="newPurpose"
        label="Purpose"
        
    ></v-text-field> -->
          <h3>Purpose</h3>
          {{ newPurpose }}
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="newType" label="Type"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="newServiceCode"
            label="Service Code"
            :items="codes"
            item-text="ServiceCode"
            item-value="ServiceCode"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12">
          <!-- <v-textarea
        v-model="newAssist"
        label="Staff will assist in:"
        outlined
        
        ></v-textarea> -->
          <h3>Staff will assist in:</h3>
          <div>
            {{ newAssist }}
          </div>
        </v-col>
        <v-col cols="12" sm="12">
          <div>Check all the following that will be needed:</div>
          <v-row>
            <v-checkbox
              label="Transportation"
              class="pa-4"
              v-model="newNeeds"
              value="Transportation"
            ></v-checkbox>
            <v-checkbox
              label="Teaching/Prompting"
              class="pa-4"
              v-model="newNeeds"
              value="Teaching/Prompting"
            ></v-checkbox>
            <v-checkbox
              label="Supervision"
              class="pa-4"
              v-model="newNeeds"
              value="Supervision"
            ></v-checkbox>
            <v-checkbox
              label="Scheduling"
              class="pa-4"
              v-model="newNeeds"
              value="Scheduling"
            ></v-checkbox>
            <v-checkbox
              label="Other"
              class="pa-4"
              v-model="newNeeds"
              value="Other"
            ></v-checkbox>
          </v-row>
        </v-col>
        <v-col class="d-flex" cols="12">
          <v-textarea
            v-model="newProvider"
            label="Provided By"
            outlined
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <!-- <v-textarea
        v-model="newInstructions"
        label="Instructions"
        outlined
    ></v-textarea> -->
          <h3>Instruction</h3>
          <div>
            {{ newInstructions }}
          </div>
        </v-col>
        <v-col cols="12">
          <!-- <v-textarea
        v-model="newChanged"
        label="We will know the supports need to be changed if:"
        outlined
    ></v-textarea> -->
          <h3>We will know the supports need to be changed if:</h3>
          <div>
            {{ newChanged }}
          </div>
        </v-col>
        <v-col cols="12">
          <!-- <v-textarea
        v-model="newReviewNotes"
        label="Review Notes"
        outlined
    ></v-textarea> -->
          <h3>Review Notes</h3>
          <div>
            {{ newReviewNotes }}
          </div>
        </v-col>

        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="newStartDate"
            label="Start Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="newEndDate"
            label="End Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="newReviewDate"
            label="Review Date"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </v-col>

        <br /><br />

        <!-- send a reminder text 7 days before -->
        <v-col cols="12" sm="12">
          <v-checkbox v-model="sign" label="Signature" @click="addSignature()"
            >Signature</v-checkbox
          >
          <v-text-field
            v-if="sign == true"
            v-model="newSignature"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <v-select label="Status" :items="status" v-model="active"> </v-select>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import Foot from "@/components/Footer";
import axios from "axios";
import moment from "moment";

const url = require("../../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: () => ({
    headers: [
      {
        text: "Start Date",
        align: "start",
        sortable: true,
        value: "StartDate",
      },
      { text: "Goal", value: "Goal" },
      { text: "Review Date", value: "ReviewDate" },
      { text: "Type", value: "Type" },
      { text: "End Date", value: "EndDate" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    tab: null,
    items: ["Active Support Strategy", "Disabled Support Strategy"],
    dialog: false,
    times: [
      "AM",
      "PM",
      "Bedtime",
      "6:00am",
      "6:00am",
      "7:00am",
      "8:00am",
      "9:00am",
      "10:00am",
      "11:00am",
      "12:00pm",
      "1:00pm",
      "2:00pm",
      "3:00pm",
      "4:00pm",
      "5:00pm",
      "6:00pm",
      "7:00pm",
      "8:00pm",
      "9:00pm",
      "10:00pm",
      "11:00pm",
      "12:00am",
    ],
    editSupport: false,
    newSupport: false,
    msg: false,
    signed: false,
    menu: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    status: ["Active", "Disabled"],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    userID: localStorage.getItem("userID"),
    clientID: null,
    staff: "",
    text: "",
    search: "",
    supports: [],
    tempData: [],
    disabled: [],
    providers: ["Behaviorist", "CNA", "Direct Care Staff"],
    LOA: [
      "Independent",
      "Moderate Assistance",
      "Minimal Assistance",
      "Total Assistance",
    ],
    codes: [],
    unitID: localStorage.getItem("unitID"),
    titleForm: "New Support Strategy",
    supportID: "",
    newGoal: "",
    newPurpose: "",
    newServiceCode: "",
    newType: "",
    newAssist: "",
    newNeeds: [],
    newProvider: "",
    newInstructions: "",
    newChanged: "",
    newReviewNotes: "",
    newReviewDate: moment(new Date()).format("YYYY-MM-DD"),
    newStartDate: moment(new Date()).format("YYYY-MM-DD"),
    newEndDate: moment(new Date()).format("YYYY-MM-DD"),
    newSignature: "",
    sign: false,
    disabledList: false,
    activeList: false,
    active: "",
    editedIndex: -1,
    editedItem: {
      goal: "",
      purpose: "",
      type: "",
      assist: "",
      needs: [],
      provider: "",
      instructions: "",
      changed: "",
      reviewNotes: "",
      reviewDate: "",
      startDate: "",
      endDate: "",
      signature: "",
    },
    defaultItem: {
      goal: "",
      purpose: "",
      type: "",
      assist: "",
      needs: [],
      provider: "",
      instructions: "",
      changed: "",
      reviewNotes: "",
      reviewDate: "",
      startDate: "",
      endDate: "",
      signature: "",
    },
    isLoading: true,
    serviceItems: [
      "Activities, Attitude and Behavior",
      "Ambulation",
      "Bathing/Showering",
      "Bed Making",
      "Behavioral Management",
      "Breakfast",
    ],
    readonly: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.clientID = this.$route.params.clientID;
    this.getSupports();
    this.getUsers();
    this.getServiceCodes();
    if (
      localStorage.getItem("userRole") == "Shift Lead" ||
      localStorage.getItem("userRole") == "House Manager" ||
      localStorage.getItem("userRole") == "Program Manager" ||
      localStorage.getItem("userRole") == "Program Coordinator"
    ) {
      this.readonly = true;
    }
  },

  methods: {
    initialize() {
      this.supports = [];
    },
    viewSupport(item) {
      // this.titleForm = "Viewing Support Strategy for " + item.Goal;
      // this.dialog = true;
      // this.editSupport = true;
      // this.newSupport = false;
      // this.newGoal = item.Goal;
      // this.newPurpose = item.Purpose;
      // this.newType = item.Type;
      // this.newServiceCode = item.ServiceCode;
      // this.newAssist = item.Assist;
      // this.newNeeds = item.Needs;
      // this.newProvider = item.Provider;
      // this.newInstructions = item.Instructions;
      // this.newChanged = item.Changed;
      // this.newReviewNotes = item.ReviewNotes;
      // this.newReviewDate = moment(item.ReviewDate).format("YYYY-MM-DD");
      // this.newStartDate = moment(item.StartDate).format("YYYY-MM-DD");
      // this.newEndDate = moment(item.EndDate).format("YYYY-MM-DD");
      // this.newSignature = item.Signature;
      // this.sign = item.Sign;
      // this.active = item.Active;
      // this.supportID = item._id;

      this.$router.push({
        path: `/support/${this.clientID}/edit`,
        query: { id: item._id, new: false },
      });
    },
    showAdd() {
      this.$router.push({
        path: `/support/${this.clientID}/add`,
      });
    },

    deleteSupport(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this support strategy?") &&
        this.supportDelete(id);
    },

    supportDelete(id) {
      axios.delete(`${url}/support/${id}`).then((response) => {
        this.getSupports();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The support strategy has been deleted successfully.";
      });
    },

    getServiceCodes() {
      axios.get(`${url}/serviceCodes/client/${this.clientID}`).then((res) => {
        this.codes = res.data.serviceCodes;
      });
    },

    close() {
      this.clear();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateSupport() {
      var req_body = {
        Goal: this.newGoal,
        Purpose: this.newPurpose,
        Type: this.newType,
        ServiceCode: this.newServiceCode,
        Assist: this.newAssist,
        Needs: this.newNeeds,
        Provider: this.newProvider,
        Instructions: this.newInstructions,
        Changed: this.newChanged,
        ReviewNotes: this.newReviewNotes,
        ReviewDate: this.newReviewDate,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Signature: this.newSignature,
        Sign: this.sign,
        Active: this.active,
      };
      axios
        .put(`${url}/support/${this.supportID}`, req_body)
        .then((response) => {
          console.log(req_body + " does this become undefined");
          this.getSupports();

          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          this.msg = true;
          this.text = "The support strategy has been updated successfully.";
          this.clear();
        });
      this.close();
    },
    getSupports: function () {
      this.isLoading = true;
      axios
        .get(`${url}/support/${this.clientID}`)
        .then((res) => {
          this.supports = [];
          this.disabled = [];
          this.tempData = res.data.supports;
          for (var k = 0; k < this.tempData.length; k++) {
            if (this.tempData[k].Active == "Active") {
              this.supports.push(this.tempData[k]);
            } else {
              this.disabled.push(this.tempData[k]);
            }
          }
          // for(var i=0;i<this.supports.length;i++){
          // // var dt = new Date(this.supports[i].ReviewDate);
          // this.supports[i].ReviewDate = moment(this.supports[i].ReviewDate).format("MM/DD/YYYY");
          // // var bt = new Date(this.supports[i].StartDate);
          // this.supports[i].StartDate = moment(this.supports[i].StartDate).format("MM/DD/YYYY");
          // // var ct = new Date(this.supports[i].EndDate);
          // this.supports[i].EndDate = moment(this.supports[i].EndDate).format("MM/DD/YYYY");
          // }
        })
        .finally(() => (this.isLoading = false));
    },

    getDisabled() {
      this.disabledList = true;
      this.supports = this.disabled;
    },

    addSupport: function () {
      var req_body = {
        Goal: this.newGoal,
        Purpose: this.newPurpose,
        Type: this.newType,
        ServiceCode: this.newServiceCode,
        Assist: this.newAssist,
        Needs: this.newNeeds,
        Provider: this.newProvider,
        Instructions: this.newInstructions,
        Changed: this.newChanged,
        ReviewNotes: this.newReviewNotes,
        ReviewDate: this.newReviewDate,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Signature: this.newSignature,
        Sign: this.sign,
        Active: this.active,
        ClientID: this.clientID,
      };

      axios.post(`${url}/support`, req_body).then((res) => {
        this.getSupports();
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.msg = true;
        this.text = "The new support strategy has been added successfully.";
      });
      this.close();
    },

    getUsers: function () {
      axios.get(`${url}/users`).then(async (res) => {
        this.users = res.data.users;
        for (var i = 0; i < this.users.length; i++) {
          if (this.userID == this.users[i]._id) {
            this.staff = this.users[i].Name;
          }
        }
      });
    },

    addSignature: function () {
      if (!this.sign) return (this.newSignature = "");
      this.newSignature = this.staff + " - " + new Date();
      this.sign = true;
    },

    clear() {
      this.newGoal = "";
      this.newPurpose = "";
      this.newType = "";
      this.newAssist = "";
      this.newNeeds = [];
      this.newServiceCode = "";
      this.newProvider = "";
      this.newInstructions = "";
      this.newChanged = "";
      this.newReviewNotes = "";
      this.newReviewDate = moment(new Date()).format("YYYY-MM-DD");
      this.newStartDate = moment(new Date()).format("YYYY-MM-DD");
      this.newEndDate = moment(new Date()).format("YYYY-MM-DD");
      this.newSignature = "";
      this.active = false;
      this.sign = false;
    },

    printTable() {
      document.getElementById("printTable").style.display = "block";
      document.getElementById("printItem").style.display = "none";

      window.print();

      document.getElementById("printTable").style.display = "none";
    },

    printItem() {
      document.getElementById("printItem").style.display = "block";
      document.getElementById("printTable").style.display = "none";

      window.print();

      document.getElementById("printItem").style.display = "none";
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

#printTable {
  display: none;
}

#printItem {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #printTable {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }
  #printItem {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
    white-space: pre-wrap;
  }
  .hideOnPrint {
    display: none;
    border: none;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
